const FundingSources = () => {
  const container = "#funding-pie-chart";

  const data = [
    { type: "taxes", value: 84 },
    { type: "state park fees", value: 7 },
    { type: "development fees", value: 4 },
    { type: "wastewater surcharge", value: 4 },
    { type: 'other', value: 1 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .style("margin-left", "8%")
    .append("g")
    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

  const path = svg
    .datum(data)
    .selectAll("path")
    .data(pie)
    .enter()
    .append("path")
    .attr("fill", (d, i) => color(i))
    .attr("d", arc)
    .each(function(d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll("text")
    .data(pie)
    .enter()
    .append("text")
    .attr("transform", d => `translate(${arc.centroid(d)})`)
    .attr("dy", "0.35em");

  text
    .append("tspan")
    .attr("x", "-0.4em")
    .attr("y", 0)
    .style("font-weight", "bold")
    .style("font-size", "1.4rem")
    .style("text-align", "center")
    .style("fill", "#FFF")
    .text(d => `${d.data.value}%`);

  const legend = d3
    .select(container)
    .append("div")
    .attr("class", "funding-legend");

  const legendItems = d3
    .select(".funding-legend")
    .selectAll(".funding-legend-item")
    .data(data);

  legendItems
    .enter()
    .append("div")
    .attr("class", "funding-legend-item")
    .style("margin-top", "25px");

  d3.selectAll(".funding-legend-item")
    .append("div")
    .attr("class", "funding-legend-rect")
    .style("width", "40px")
    .style("height", "20px")
    .style("background-color", function(d, i) {
      return color(i);
    });

  d3.selectAll(".funding-legend-item")
    .append("div")
    .attr("class", "funding-legend-text")
    .text(d => d.type);
};

const FundingSplit = () => {
  const container = "#funding-pie-chart";

  const data = [
    { type: "Pollution Abatement Projects", value: 60 },
    { type: "Special Projects", value: 40 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .style("margin-left", "8%")
    .append("g")
    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

  const path = svg
    .datum(data)
    .selectAll("path")
    .data(pie)
    .enter()
    .append("path")
    .attr("fill", (d, i) => color(i))
    .attr("d", arc)
    .each(function(d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll("text")
    .data(pie)
    .enter()
    .append("text")
    .attr("transform", d => `translate(${arc.centroid(d)})`)
    .attr("dy", "0.35em");

  text
    .append("tspan")
    .attr("x", "-0.4em")
    .attr("y", 0)
    .style("font-weight", "bold")
    .style("font-size", "1.4rem")
    .style("text-align", "center")
    .style("fill", "#FFF")
    .text(d => `${d.data.value}%`);

  const legend = d3
    .select(container)
    .append("div")
    .attr("class", "funding-legend");

  const legendItems = d3
    .select(".funding-legend")
    .selectAll(".funding-legend-item")
    .data(data);

  legendItems
    .enter()
    .append("div")
    .attr("class", "funding-legend-item")
    .style("margin-top", "25px");

  d3.selectAll(".funding-legend-item")
    .append("div")
    .attr("class", "funding-legend-rect")
    .style("width", "40px")
    .style("height", "20px")
    .style("background-color", function(d, i) {
      return color(i);
    });

  d3.selectAll(".funding-legend-item")
    .append("div")
    .attr("class", "funding-legend-text")
    .text(d => d.type);
};

const CIPTable = () => {
  const CIPData = [
    {
      "Project Title": "CCSP Meteorological Station (UCCWA)",
      "Total": "$20",
      "Authority Portion": "$10",
      "Proposed 2021 Budget": "$10",
      "Out-year Budget": "---",
      "Funding Year(s)": 2021
    },
    {
      "Project Title": "Reservoir Destratification System - Distribution Preliminary Design - Includes evaluation of Optimization of Distribution with WWE Expansion Alternative",
      "Total": "$270",
      "Authority Portion": "$270",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$270",
      "Funding Year(s)": 2022
    },
    {
      "Project Title": "East Shade Shelter Shoreline Stabilization Phase III",
      "Total": "$350",
      "Authority Portion": "$140",
      "Proposed 2021 Budget": "$140",
      "Out-year Budget": "---",
      "Funding Year(s)": 2021
    },
    {
      "Project Title": "West Shade Shelter Shoreline Stabilization PRF",
      "Total": "$950",
      "Authority Portion": "$950",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$950",
      "Funding Year(s)": "2023-2025"
    },
    {
      "Project Title": "Tower Loop Shoreline Stabilization Phase II",
      "Total": "$700",
      "Authority Portion": "$905",
      "Proposed 2021 Budget": "$660",
      "Out-year Budget": "$245",
      "Funding Year(s)": "2021-2022"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation at Main Street (Parker)",
      "Total": "$1,776",
      "Authority Portion": "$200",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$200",
      "Funding Year(s)": 2028
    },
    {
      "Project Title": "Cherry Creek Stream Stabilization at Lincoln Avenue (Parker)",
      "Total": "$1,447",
      "Authority Portion": "$304",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$304",
      "Funding Year(s)": 2029
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation - Reach 3",
      "Total": "$2,567",
      "Authority Portion": "$640",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$640",
      "Funding Year(s)": "2029-2030"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation - Reach 4",
      "Total": "$2,720",
      "Authority Portion": "$680",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$680",
      "Funding Year(s)": "2028-2029"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation - CCSP 12-mile Phase III",
      "Total": "$490",
      "Authority Portion": "$490",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$490",
      "Funding Year(s)": "2025"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation - CCSP 12-mile Phase III",
      "Total": "$550",
      "Authority Portion": "$550",
      "Proposed 2021 Budget": "$300",
      "Out-year Budget": "$145",
      "Funding Year(s)": "2021-2026"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation - U/S Scott Road (Douglas County)",
      "Total": "$2,500",
      "Authority Portion": "$625",
      "Proposed 2021 Budget": "$275",
      "Out-year Budget": "$275",
      "Funding Year(s)": "2021-2022"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation - at Dranfeldt Extension (Parker)",
      "Total": "$3,048",
      "Authority Portion": "$400",
      "Proposed 2021 Budget": "$60",
      "Out-year Budget": "$340",
      "Funding Year(s)": "2021-2025"
    },
    {
      "Project Title": "McMurdo Gulch Reclamation (Castle Rock)",
      "Total": "$4,157",
      "Authority Portion": "$1,035",
      "Proposed 2021 Budget": "$540",
      "Out-year Budget": "---",
      "Funding Year(s)": 2021
    },
    {
      "Project Title": "Cottonwood Creek at Briarwood  (SEMSWA)",
      "Total": "$850",
      "Authority Portion": "$140",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$140",
      "Funding Year(s)": "2022-2024"
    },
    {
      "Project Title": "Cottonwood Creek downstream of Easter (SEMSWA)",
      "Total": "$800",
      "Authority Portion": "$160",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$160",
      "Funding Year(s)": "2024-2026"
    },
    {
      "Project Title": "Cottonwood Creek Tributary - Shooting Area Tributary (CCSP)",
      "Total": "$300",
      "Authority Portion": "$75",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$75",
      "Funding Year(s)": 2028
    },
    {
      "Project Title": "Cottonwood Creek and Tributary C (IWSD)",
      "Total": "$1,664",
      "Authority Portion": "$416",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$416",
      "Funding Year(s)": 2030
    },
    {
      "Project Title": "Lone Tree Creek in CCSP (Centennial)",
      "Total": "$715",
      "Authority Portion": "$179",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$179",
      "Funding Year(s)": 2026
    },
    {
      "Project Title": "Happy Canyon Creek Jordan Road to Broncos Parkway  (SEMSWA)",
      "Total": "$1,300",
      "Authority Portion": "$325",
      "Proposed 2021 Budget": "$25",
      "Out-year Budget": "$300",
      "Funding Year(s)": "2021-2026"
    },
    {
      "Project Title": "Happy Canyon Creek Upstream of I-25 (MHFD)",
      "Total": "$2,000",
      "Authority Portion": "$500",
      "Proposed 2021 Budget": "$250",
      "Out-year Budget": "$250",
      "Funding Year(s)": "2021-2022"
    },
    {
      "Project Title": "Dove Creek U/S Pond D-1 to Chambers Rd  (SEMSWA)",
      "Total": "$650",
      "Authority Portion": "$163",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$163",
      "Funding Year(s)": "2022-2024"
    },
    {
      "Project Title": "Dove Creek Otero to Chambers Rd.  (SEMSWA)",
      "Total": "$700",
      "Authority Portion": "$175",
      "Proposed 2021 Budget": "$25",
      "Out-year Budget": "$150",
      "Funding Year(s)": "2021-2023"
    },
    {
      "Project Title": "Piney Creek Reach 1 to 2  (SEMSWA)",
      "Total": "$1,500",
      "Authority Portion": "$375",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$375",
      "Funding Year(s)": "2025-2028"
    },
    {
      "Project Title": "Piney Creek Tower to Orchard  (SEMSWA)",
      "Total": "$2,200",
      "Authority Portion": "$550",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$550",
      "Funding Year(s)": "2024-2027"
    },
    {
      "Project Title": "Lone Tree Creek Pond L-3 Retrofit  (SEMSWA)",
      "Total": "$70",
      "Authority Portion": "$18",
      "Proposed 2021 Budget": "$18",
      "Out-year Budget": "---",
      "Funding Year(s)": 2021
    },
    {
      "Project Title": "Windmill Creek Pond W-9 Retrofit  (SEMSWA)",
      "Total": "$150",
      "Authority Portion": "$38",
      "Proposed 2021 Budget": "---",
      "Out-year Budget": "$38",
      "Funding Year(s)": 2023
    },
    {
      "Project Title": "PRF Preservation, Acquisition, Lease of Land or Water",
      "Total": "$500",
      "Authority Portion": "$500",
      "Proposed 2021 Budget": "$50",
      "Out-year Budget": "$450",
      "Funding Year(s)": "2022-2030"
    },
    {
      "Project Title": "Total Capital Projects",
      "Total": "$34,943",
      "Authority Portion": "$10,312",
      "Proposed 2021 Budget": "$2,353",
      "Out-year Budget": "$7,785",
      "Funding Year(s)": ""
    },
    {
      "Project Title": "Rehabilitation",
      "Total": "$900",
      "Authority Portion": "",
      "Proposed 2021 Budget": "$90",
      "Out-year Budget": "$810",
      "Funding Year(s)": "2021-2030"
    },
    {
      "Project Title": "Restorative",
      "Total": "$2,319",
      "Authority Portion": "",
      "Proposed 2021 Budget": "$264",
      "Out-year Budget": "$2,055",
      "Funding Year(s)": "2021-2030"
    },
    {
      "Project Title": "Routine",
      "Total": "$480",
      "Authority Portion": "",
      "Proposed 2021 Budget": "$48",
      "Out-year Budget": "$432",
      "Funding Year(s)": "2021-2030"
    },
    {
      "Project Title": "Operations",
      "Total": "$860",
      "Authority Portion": "",
      "Proposed 2021 Budget": "$86",
      "Out-year Budget": "$774",
      "Funding Year(s)": 2021
    },
    {
      "Project Title": "Total Operations and Maintenance",
      "Total": "$4,559",
      "Authority Portion": "",
      "Proposed 2021 Budget": "$488",
      "Out-year Budget": "$4,071",
      "Funding Year(s)": "2021-2030"
    }
  ];

  // Declare and configure request overview table
  const table = new requestTable({
    container: "#cip-table",
    filterEnabled: false,
    tableHeaders: {
      "Project Title": "Project Title",
      Total: "Current Total Budget",
      "Authority Portion": "Current Authority Portion",
      "Proposed 2021 Budget": "Proposed 2021 Budget",
      "Out-year Budget": "Out-year Budget",
      "Funding Year(s)": "Funding Year(s)",
    },
    tableActions: [],
    tableData: CIPData,
  });
  table.buildTable();
};
